import { create as gallery } from './gallery';
import { create as lightbox } from './lightbox';
import { create as montage } from './montage';
import { init as locationMap } from './location-map';
import { DatePicker } from './datepicker';
import addDays from 'date-fns/addDays';

export function init() {
	const galleryElement = document.querySelector('.js-property-gallery');
	const montageElement = document.querySelector('.js-property-montage');
	const lightboxElement = document.querySelector('.js-property-lightbox');

	const galleryImages = document.querySelectorAll('.js-gallery-image');

	locationMap();
	createGallery();

	function createGallery() {
		if (!galleryElement) {
			return;
		}

		const galleryInstance = gallery(galleryElement);
		const lightboxInstance = lightbox(lightboxElement);
		const montageInstance = montage(montageElement);

		if (!galleryInstance) {
			return;
		}

		montageInstance.items.forEach(function(item, index) {
			item.addEventListener('click', function() {
				lightboxInstance.open(index);
			});
		});

		galleryImages.forEach(function(item, index) {
			item.addEventListener('click', function() {
				montageInstance.open(index);
			});
		});
	}

	const container = document.querySelector('.js-availability-calendar');

	if (!container) {
		return;
	}

	const dates = {
		start: undefined,
		end: undefined,
		nights: undefined,
	};

	let calendar = createCalendar();
	let id = container.dataset.id;

	let modifiers = {
		available: [],
		changeOver: [],
		unavailable: [],
		bookingStart: [],
		bookingEnd: [],
		highlighted: undefined,
	};

	fetch(buildUrl('/actions/supercontrol/calendar/get-dates', { id }), {
		headers: { Accept: 'application/json' },
	})
		.then(response => response.json())
		.then(json => {
			for (let i = 0; i < json.dates.length; i++) {
				let item = json.dates[i];
				let date = new Date(item.date);

				if (item.changeOver === 'C' || item.changeOver === 'I') {
					modifiers.changeOver.push(new Date(date));
				}

				if (item.bookingStart) {
					modifiers.bookingStart.push(new Date(date));
				}

				if (item.bookingEnd) {
					modifiers.bookingEnd.push(new Date(date));
				}

				if (item.available) {
					modifiers.available.push(new Date(date));
				} else {
					modifiers.unavailable.push(new Date(date));
				}
			}

			calendar.set('modifiers', modifiers);
			calendar.set('minDate', new Date(json.minDate));
			calendar.set('maxDate', new Date(json.maxDate));
		});

	function createCalendar() {
		function bookingDate(rawDate) {
			let date = new Date(rawDate.getTime());

			let day = String(date.getDate()).padStart(2, '0');
			let month = String(date.getMonth() + 1).padStart(2, '0');
			let year = date.getFullYear();

			return [day, month, year].join('/');
		}

		let screenTablet = window.matchMedia('screen and (min-width: 800px) and (max-width: 1199px)');
		let screenLarge = window.matchMedia('screen and (min-width: 1200px)');

		window.addEventListener('DOMContentLoaded', () => {
			calendar.set('numberOfMonths', calcNumberOfMonths());
		});

		window.addEventListener('resize', () => {
			calendar.set('numberOfMonths', calcNumberOfMonths());
		});

		window.addEventListener('orientationchange', () => {
			calendar.set('numberOfMonths', calcNumberOfMonths());
		});

		function calcNumberOfMonths() {
			return screenLarge.matches ? 3 : screenTablet.matches ? 2 : 1;
		}

		function setStartDate(date) {
			let defaultNights = 4;

			dates.start = date;
			let arrivalDate = bookingDate(dates.start);
			let departureDate = addDays(date, defaultNights);
			dates.end = departureDate;
			departureDate = bookingDate(dates.end);

			let cartDetails = {};
			cartDetails['action'] = 'cartOpen';
			cartDetails['arrivalDate'] = arrivalDate;
			cartDetails['departureDate'] = departureDate;
			cartDetails['numberNights'] = defaultNights;
			// cartDetails['capacity'] = '2'; // doesn't function currently 22-01-19
			cartDetails['cottageID'] = id;

			window.postMessage(cartDetails, '*');
		}

		return DatePicker({
			container: container,
			numberOfMonths: calcNumberOfMonths(),
			weekStartsOn: 1,
			fixedWeeks: true,
			onDayClick: event => {
				const { date } = event;

				if (event.modifiers.available) {
					setStartDate(date);
				}
			},
		});
	}

	function buildUrl(url, params) {
		let encodedParams = [];

		for (let [key, value] of Object.entries(params)) {
			encodedParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
		}

		return `${url}?${encodedParams.join('&')}`;
	}
}
